export default "__VITE_ASSET__DJDW2FSF__"